import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, MapPin, Plane } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { COUNTRY_GUIDES, slugifyCountry } from "../data/countries";

export default function CountryGuides() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#f6f8fc] flex flex-col">
      <Header />
      <main className="flex-1">
        <section className="bg-[#16244F] py-14 md:py-16">
          <div className="max-w-[1240px] mx-auto px-5 text-center">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#F58220]/20 text-[#F9B57C] text-xs font-semibold font-head">
              <Plane size={14} /> STUDY DESTINATIONS
            </span>
            <h1 className="font-head text-3xl md:text-5xl font-bold text-white mt-4">Country Guides</h1>
            <p className="text-white/75 mt-4 max-w-2xl mx-auto">Visa rules, cost of living, intakes and post-study work — everything you need to plan your study abroad journey.</p>
          </div>
        </section>

        <section className="max-w-[1240px] mx-auto px-5 py-10 md:py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {COUNTRY_GUIDES.map((c) => (
              <article key={c.name} onClick={() => navigate(`/destinations/${slugifyCountry(c.name)}`)} className="cursor-pointer bg-white rounded-2xl cc-shadow-card overflow-hidden group hover:-translate-y-1 transition-transform duration-300 flex flex-col">
                <div className="relative h-44 overflow-hidden">
                  <img src={c.image} alt={c.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  <div className="absolute bottom-3 left-4 text-white font-head text-xl font-bold flex items-center gap-2"><span className="text-2xl">{c.flag}</span> {c.name}</div>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <p className="text-sm text-[#5a6274] flex-1">{c.tagline}</p>
                  <div className="flex items-center gap-1.5 text-xs text-[#2b8cf0] font-semibold mt-3"><MapPin size={13} /> {c.popularCities.slice(0, 3).join(" · ")}</div>
                  <span className="mt-4 inline-flex items-center gap-1 text-[#F58220] font-head font-semibold text-sm group-hover:gap-2 transition-all">Read guide <ArrowRight size={15} /></span>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
